// extracted by mini-css-extract-plugin
export default {"banner":"alertbanner_banner__BbHF6","text":"alertbanner_text__nQAJr"};